const moreText = () => {
  const paragraphs = document.querySelectorAll('.js-more-text');

  if (paragraphs) {
    paragraphs.forEach(paragraph => {
      const trimmed = paragraph.querySelector('.js-more-text-trimmed');
      const untrimmed = paragraph.querySelector('.js-more-text-untrimmed');
      const expand = paragraph.querySelector('.js-more-text-expand');
      const collapse = paragraph.querySelector('.js-more-text-collapse');

      if (expand) {
        expand.addEventListener('click', () => {
          trimmed.classList.add('u-hidden@less-then-medium');
          untrimmed.classList.remove('u-hidden@less-then-medium');
        });
      }

      if (collapse) {
        collapse.addEventListener('click', () => {
          trimmed.classList.remove('u-hidden@less-then-medium');
          untrimmed.classList.add('u-hidden@less-then-medium');
        });
      }
    });
  }
};

export default moreText;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/moreText.js